var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlirting(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 36.5,
    r: 36.5,
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_46_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37 18C25.3983 18 16 25.3777 16 34.4793C16 40.4187 20.0126 45.6042 26.0154 48.5062L20.578 58L34.4962 50.8302C35.3184 50.9063 36.1519 50.9587 37 50.9587C48.6017 50.9587 58 43.581 58 34.4793C58 25.3777 48.6017 18 37 18ZM37 43.3528C20.5489 32.2618 29.2898 26.4509 32.632 26.4509C35.971 26.4509 37 29.8313 37 29.8313C37 29.8313 38.0274 26.4509 41.3696 26.4509C44.7102 26.4509 53.4511 32.2618 37 43.3528Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_46_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 40,
    fill: "white",
    transform: "translate(16 18)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlirting);
export default __webpack_public_path__ + "static/media/flirting.5197535ee246ac6d28b94cdbdebde5be.svg";
export { ForwardRef as ReactComponent };